import { TimesheetLine, TimesheetLinesByDate } from '../../../domain/timesheets-domain';

// creates an array of group timesheet lines by date
export function groupTimesheetLinesByDate(timesheetLines: TimesheetLine[]) {
  let totalHoursAccumulated = 0;

  const newTimesheetLines = timesheetLines.reduce((timesheetLinesAccumulator: TimesheetLinesByDate[], currentValue) => {
    const isSameDate = timesheetLinesAccumulator.find((accumulator) => accumulator.date === currentValue.activityDate);
    let accumulatorHolder: TimesheetLinesByDate[];

    if (isSameDate) {
      accumulatorHolder = timesheetLinesAccumulator.map((accumulator) => {
        if (accumulator.date === currentValue.activityDate) {
          return {
            date: accumulator.date,
            totalHours: accumulator.totalHours + currentValue.totalTime,
            timesheetLines: [...accumulator.timesheetLines, currentValue],
          };
        }

        return accumulator;
      });
    } else {
      accumulatorHolder = [...timesheetLinesAccumulator, { date: currentValue.activityDate, timesheetLines: [currentValue], totalHours: currentValue.totalTime }];
    }

    // calculate total hours accumulated per entry filtered
    totalHoursAccumulated = accumulatorHolder.reduce((accumulatorHolderValue, accumulatorHolderCurrentValue) => accumulatorHolderValue + accumulatorHolderCurrentValue.totalHours, 0);

    return accumulatorHolder;
  }, []);

  return { newTimesheetLines, totalHoursAccumulated };
}
